





















import { Component, Vue } from "vue-property-decorator";
import TabBar from "@/basics/tab/TabBar.vue";
import TabItem from "@/basics/tab/TabItem.vue";
import {
  OneAppUserData,
  ONE_APP_USER,
  OneAppUserVariables
} from "@/graphql/query/appUser/one";

export interface AppUser {
  name: string;
}

@Component({
  components: {
    TabBar,
    TabItem
  },
  apollo: {
    appUser: {
      query: ONE_APP_USER,
      variables(): OneAppUserVariables {
        return { id: this.$apollo.vm.$route.params.appUserId };
      },
      update(data: OneAppUserData): AppUser {
        return data.appUser;
      }
    }
  }
})
export default class TabFrame extends Vue {
  appUser: AppUser | null = null;
}
